import { styled, Box } from '@mybonus/ui';

export const Wrapper = styled(Box)`
	width: 100%;
	height: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
`;
